import { useMutation, useQuery, } from "react-query";
import { useToast } from "../../../hooks/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { getRequest, postRequest } = DataService()

export const useGetTransaction = ({ page, size, searchText, sortOrder, sortField, type, currency, network }) => {

    return useQuery({
        queryKey: ["historyList-list", page, size, searchText, sortOrder, sortField, type, currency, network],
        queryFn: () => {
            return getRequest(`/user-transactions?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}&network=${network}`)
        }
    })
}

export const useUpdateCurrency = () => {

    return useMutation({
        mutationFn: (data) => {
            return postRequest("/admin-update-reqsent", { ...data })
        },

        onSuccess: success => {
            queryClient.refetchQueries('historyList-list')

        }
    })
}


export const ReferralTransaction = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["Referral-list", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/users-referral-history?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}`)
        }
    })
}

export const ReferralRewardUpdate = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest('/update-referral-reward', { ...data });
        },
        onError: (error) => {
            toast.error(error?.message || 'Referral-reward update failed');
        },
        onSuccess: (success) => {
            queryClient.invalidateQueries(['Referral-reward']);
            toast.success(success?.data?.message || 'Referral-reward updated successfully');
        },
    });
};


export const useGetReferral = () => {

    return useQuery({
        queryKey: ["Referral-reward"],
        queryFn: () => {
            return getRequest(`/get-referral-data`)
        }
    })
}


export const useUpdatehistory = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["Referral-reward", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/referral-history-list?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}`)
        }
    })
}

export const useGetRewardFailed = ({ id, page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["Referral-failed", id, page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/failed-reward-list?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}`)
        }
    })
}

export const useUpdateReward = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/qhaxmzbavty", data)
        },
    })
}

export const useGetCashbackHistory = ({ id, page, size, searchText, sortField, sortOrder, type }) => {
    return useQuery({
        queryKey: ["Cashback-history", id, page, size, searchText, sortField, sortOrder, type],
        queryFn: () => {
            return getRequest(`/austeargakh?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}&type=${type}`)
        }
    })
}


export const useGetAdminEditHistory = ({ page, size, searchText, sortField, sortOrder }) => {
    return useQuery({
        queryKey: ["adminEdit-history", page, size, searchText, sortField, sortOrder],
        queryFn: () => {
            return getRequest(`/get-admin-edit-history?page=${page}&size=${size}&sortOrder=${sortOrder}&search=${searchText}&sortField=${sortField}`)
        }
    })
}

export const useReferralManage = ({ page, size, searchText, }) => {
    return useQuery({
        queryKey: ["Referral-data", page, size, searchText,],
        queryFn: () => {
            return getRequest(`/lagbnstjsoy?page=${page}&size=${size}`)
        }
    })
}

export const useUpdateReferral = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/lqusghdbn", data)
        },
        onSuccess: (success) => {
            queryClient.invalidateQueries(['Referral-data']);

        },
    })
}

export const useGetCashbackBalance = () => {

    return useQuery({
        queryKey: ["Referral-cashback"],
        queryFn: () => {
            return getRequest(`/mnbgtuofyogs`)
        }
    })
}

export const useGenerateReferLink = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/nbgqwxvjua", data)
        },
    })
}


export const useUpdateReferralLink = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/nbgqwxvjua", data)
        },
        onSuccess: (success) => {
            queryClient.invalidateQueries(['Referral-reward']);

        },
    })
}